module.exports = __webpack_public_path__ + "images/sprites/ui/headline_icon_bu_3d2a598b7274402561a775457da8cc08.png";